import { Component } from '@angular/core';
import { SplitFlapBoard } from '../../components/split-flap-board/split-flap-board';
import { BoardConfig, BoardMessage } from '../../models/board.model';

@Component({
  selector: 'app-demo',
  standalone: true,
  imports: [SplitFlapBoard],
  templateUrl: './demo.html',
  styleUrl: './demo.css',
})
export class Demo {
  // Board configuration
  protected readonly config: BoardConfig = {
    rows: 6,
    columns: 20,
    rotationInterval: 20, // Rotate every 20 seconds
  };

  // Demo messages to rotate through
  protected readonly messages: BoardMessage[] = [
    {
      id: 'demo-1',
      text: '  FlippyBoards.com! Create a board, add a feed, and start   flipping. We hope   you have a flipping good time.',
      order: 1,
    },
    {
      id: 'demo-2',
      text: 'Create a feed from  your calendars,     blusky feed, or     GitHub repository.  Edit your own feed  like this demo.',
      order: 2,
    },
    {
      id: 'demo-3',
      text: 'Create your own     alphabet to flip.   Add emojis, color   blanks, or accent   characters. Omit    extra punctuation.',
      order: 3,
    },
    {
      id: 'demo-4',
      text: 'Share your boards   with friends and    colleagues. Set a   password for        family or group onlyboards.',
      order: 4,
    },
    {
      id: 'demo-5',
      text: 'Premium features    include AI language Translation servicesMFA to secure your  boards, and more!',
      order: 5,
    },
  ];
}